import { STEP_STATES } from './constants'

export const getStepState = (stepIndex, activeStepIndex) => {
  if (stepIndex < activeStepIndex) {
    return STEP_STATES.completed
  }
  return stepIndex === activeStepIndex ? STEP_STATES.active : STEP_STATES.none
}
